import React, { useState, useRef, useEffect, Fragment } from "react";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BoLoader from "../../helpers/BoLoader";
import BoPaymentWrapper from "../BoPaymentLeftWrapper";
import useWindowDimensions from "../../helpers/WindowWidth";
import identityverificationObj from "../../services/identityverification.service";
import DialoguePopup from "../../helpers/DialoguePopup";
import cardsService from "../../services/cards.services";
import ModelPopup from "../../helpers/ModelPopup";

const RegisterIssuerT = () => {
  const form = useRef();
  const { user: currentUser } = useSelector((state) => state.auth);
  const [UserId, setUserId] = useState(String(currentUser?.user?.UserId));
  const [boloader, setBoLoader] = useState(false);
  const [kycId, setKycId] = useState();
  const [kycDocLength, setKycDocsLength] = useState(0);
  const [kycstatus, setKycstatus] = useState(0);
  const [kycmessage, setKycmessage] = useState();
  const [isValidFileId, setisValidFileId] = useState(true);
  const [isValidFileIdSize, setisValidFileIdSize] = useState(true);
  const [isValidFileIdBack, setisValidFileIdBack] = useState(true);
  //Dialogue Popup
  const [modalShow, setModalShow] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [successfulSubmitted, setSuccessfulSubmitted] = useState(false);
  const [LogoNameID, setlogoNameID] = useState("");
  const [LogoNameIDBack, setlogoNameIDBack] = useState("");
  const [LogoNameSelfie, setlogoNameSelfie] = useState("");
  const [LogoNamePOF, setlogoNamePOF] = useState("");
  const [LogoNamePOFBack, setlogoNamePOFBack] = useState("");
  const [LogoSizeID, setlogoSizeID] = useState();
  const [LogoSizeSelfie, setlogoSizeSelfie] = useState();
  const [LogoSizeIDBack, setlogoSizeIDBack] = useState();
  const [LogoSizePOF, setlogoSizePOF] = useState();
  const [LogoSizePOFBack, setlogoSizePOFBack] = useState();
  const [isValidIdType, setiisValidIdType] = useState(true);
  const [isValidIdTypeBack, setiisValidIdTypeBack] = useState(true);
  const [isValidProofofAdrs, setiisValidProofofAdrs] = useState(true);
  const [isValidProofofAdrsBack, setiisValidProofofAdrsBack] = useState(true);
  const [isValidLogoIdType, setiisValidLogoIdType] = useState(true);
  const [isValidLogoSelfieType, setiisValidLogoSelfieType] = useState(true);
  const [isValidLogoIdTypeBack, setiisValidLogoIdTypeBack] = useState(true);
  const [isValidLogoProofofAdrs, setisValidLogoProofofAdrs] = useState(true);
  const [isValidLogoProofofAdrsBack, setisValidLogoProofofAdrsBack] = useState(true);
  const [isValidFilePoaBack, setiisValidFilePoaBack] = useState(true);
  const { height, width } = useWindowDimensions();
  const [Name, setBoUserName] = useState("");
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const [clientlogo, setclientlogo] = useState("");
  const [StateId, setStateID] = useState();
  const [AddressProof, setAddressProof] = useState();
  const [AddressProofBack, setAddressProofBack] = useState();
  const [IDType, setIDType] = useState(0);
  const [LinkTG, setLinkTG] = useState("");
  const [CardOwnerName, setCardOwnerName] = useState("");
  const [modalsuccessfullShow, setModalsuccessfullShow] = useState(false);

  useEffect(() => {
    if(currentUser?.user?.IssuerName === "IssuerTG"||currentUser?.user?.IssuerName === "IssuerTGV" )
    viewCardHolderTG();
    if(currentUser?.user?.IssuerName === "IssuerZ")
      viewCardHolderZ();
     if(currentUser?.user?.IssuerName === "IssuerZD")
      viewCardHolderZD();
    if(currentUser?.user?.IssuerName === "IssuerER")
      viewCardHolderER();

  }, [])
 
  const viewCardHolderTG = () => {
    setBoLoader(true);
    identityverificationObj.viewcardholdertg(UserId).then(
      (response) => {
        setBoLoader(false);
        setKycId(response?.data?.payload?.item1?.kycDocs[0]?.kycDocID);
        setKycDocsLength(response?.data?.payload?.item1?.kycDocs?.length);
        setKycstatus(response?.data?.payload?.item1?.status);
        if(response?.data?.payload?.item1?.status==4){
          submitkyctoissuertg();
          // approveRejectKyc(true);
        }
        else if(response?.data?.payload?.item1?.status==3){
          setLinkTG(response?.data?.payload?.item1?.sysRes2);
        }
        else if(response?.data?.payload?.item1?.status==1){
          approveRejectKyc(true);
          setLinkTG("Approved")
        }
        else{
          setLinkTG("");
        }
         setLinkTG(response?.data?.payload?.item1?.sysRes2)
      },
      (error) => {
        setBoLoader(false);
      }
    );
  }
  const viewCardHolderER = () => {
    setBoLoader(true);
    identityverificationObj.viewcardholderer(UserId).then(
      (response) => {
        setBoLoader(false);
        setKycId(response?.data?.payload?.item1?.kycDocs[0]?.kycDocID);
        setKycDocsLength(response?.data?.payload?.item1?.kycDocs?.length);
        setKycstatus(response?.data?.payload?.item1?.status);
        if(response?.data?.payload?.item1?.status==4){
          submitkyctoissuertg();
        }
        else if(response?.data?.payload?.item1?.status==3){
          setLinkTG(response?.data?.payload?.item1?.sysRes2);
        }
        else if(response?.data?.payload?.item1?.status==1){
          approveRejectKyc(true);
          setLinkTG("Approved")
        }
        else{
          setLinkTG("");
        }
         setLinkTG(response?.data?.payload?.item1?.sysRes2)
      },
      (error) => {
        setBoLoader(false);
      }
    );
  }
 
  const viewCardHolderZ = () => {
    setBoLoader(true);
    identityverificationObj.viewcardholderZ(UserId).then(
      (response) => {
        setBoLoader(false);
        setKycstatus(response?.data?.payload?.item1?.message);
        setLinkTG(response?.data?.payload?.item1?.sumsubLink)
      
      },
      (error) => {
        setBoLoader(false);
      }
    );
  }
  const viewCardHolderZD = () => {
    setBoLoader(true);
    identityverificationObj.viewcardholderZD(UserId).then(
      (response) => {
        setBoLoader(false);
        setKycstatus(response?.data?.payload?.item1?.provider_status);
        setKycmessage(response?.data?.payload?.item1?.provider_reason);
        setLinkTG(response?.data?.payload?.item1?.sumsub_link)
      
      },
      (error) => {
        setBoLoader(false);
      }
    );
  }
  const approveRejectKyc = (stat) => {
    if(stat){
  setBoLoader(true);
    cardsService
      .approverejectkyc(UserId, stat)
      .then((res) => {
        setBoLoader(false);
        if (res && res.data && res.data.success) {
      let user = JSON.parse(sessionStorage.getItem("user"));
      if (user) {
          user.KycApprovedByIssuer = "Yes"; 
          user.IsKycSubmitted=true;
          sessionStorage.setItem("user", JSON.stringify(user));
          //window?.location?.reload();
        }  
        }
      })
      .catch((err) => {
        setBoLoader(false);
        
      });
    }
  
  };

  useEffect(() => {
    setiisValidIdType(true);
  }, [IDType]);

  useEffect(() => {
    setiisValidProofofAdrs(true);
  }, [AddressProof]);
  useEffect(() => {
    setiisValidProofofAdrsBack(true);
  }, [AddressProofBack]);
  useEffect(() => {
    setiisValidLogoIdType(true);
  }, [LogoNameID]);
  useEffect(() => {
    setiisValidLogoIdTypeBack(true);
  }, [LogoNameIDBack]);
  useEffect(() => {
    setisValidLogoProofofAdrs(true);
  }, [LogoNamePOF]);
  useEffect(() => {
    setisValidLogoProofofAdrsBack(true);
  }, [LogoNamePOFBack]);
  useEffect(() => {
    setisValidFileId(true);
  }, [setlogoSizeID]);
  useEffect(() => {
    setisValidFileIdSize(true);
  }, [setlogoSizeID]);
  useEffect(() => {
    setisValidFileIdBack(true);
  }, [setlogoSizeIDBack]);
  useEffect(() => {
    setiisValidFilePoaBack(true);
  }, [setlogoSizePOFBack]);
 
  
  
  const errorAndSuccessModl = (heading, body, errIcon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };
 

  const submitkyctoissuertg=()=>{
  identityverificationObj.submitkyctoissuertg(UserId).then((response)=>{
    if(response){
      setLinkTG(response?.payload);
      viewCardHolderTG();
    }
  }).catch((err)=>{
    let msgBody = err?.response?.data?.message
    ? err.response.data.message : "Something Went Wrong" + "-" + "Please Contact support for assistance"

  let errIcon = "icon-error";
  errorAndSuccessModl("Error", msgBody, errIcon);
  });
  }
  const regeneratekyclink=()=>{
    identityverificationObj.regeneratekyclink(UserId).then((response)=>{
      if(response){
        setLinkTG(response?.payload);
        let msgBody = response?.data?.message
      ? response?.data?.message : "New Link Generated"
  
    let errIcon = "icon-success";
    errorAndSuccessModl("Error", msgBody, errIcon);
      }
    }).catch((err)=>{
      let msgBody = err?.response?.data?.message
      ? err.response.data.message : "Something Went Wrong" + "-" + "Please Contact support for assistance"
  
    let errIcon = "icon-error";
    errorAndSuccessModl("Error", msgBody, errIcon);
    });
    }
    const regeneratekyclinkZ=()=>{
      identityverificationObj.regeneratekyclinkZ(UserId).then((response)=>{
        if(response){
          setLinkTG(response?.payload);
          let msgBody = response?.data?.message
        ? response?.data?.message : "New Link Generated"
    
      let errIcon = "icon-success";
      errorAndSuccessModl("Success", "New Link Generated", errIcon);
        }
      }).catch((err)=>{
        let msgBody = err?.response?.data?.message
        ? err.response.data.message : "Something Went Wrong" + "-" + "Please Contact support for assistance"
    
      let errIcon = "icon-error";
      errorAndSuccessModl("Error", msgBody, errIcon);
      });
      }
   
    const onChangeKCardOwnerName = (e) => {
      const number = e.target.value;
      if (number != "") {
        let value = number;
        setCardOwnerName(value);
      }
  
    };
    const requiredCardOwnerName = (value) => {
      if (!value) {
        document.getElementById("card_owner_name").classList.add("has_error");
        return (
          <span className="help-block">Card Owner Name is required!</span>
        );
      } else
        document
          .getElementById("card_owner_name")
          .classList.remove("has_error");
    };
    const maxLengthCheck = object => {
      if (object.target.value.length > object.target.maxLength) {
        object.target.value = object.target.value.slice(
          0,
          object.target.maxLength
        );
      }
      var t = object.target.value;
      if (t.includes("."))
        object.target.value = (t?.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
    };
    const submitCardVerification = (e) => {  
      e.preventDefault();
      setBoLoader(true);
          cardsService.ActivatePhysicalCardZ("","",
            UserId)
            .then(() => {
              setModalsuccessfullShow(true);
              setBoLoader(false);
            })
            .catch((error) => {
              setBoLoader(false);
              let msgBody = error?.response?.data?.message
                ? error?.response?.data?.message
    
                : "Error Occured";
              let errIcon = "icon-error";
              errorAndSuccessModl("Error", msgBody, errIcon);
            });
      
    };
    const logoutUser = () => {
      sessionStorage.removeItem("user");
      window.location.reload();
    }
    if(currentUser?.user?.IssuerName=="IssuerTG" && LinkTG=="Approved")
      return <Redirect to="/cardverification" />;
  return (
    <div className="row">
      <BoLoader loading={boloader} />
      {width > 767 && <BoPaymentWrapper
        pagename={["Uploads Your", <br />, "Kyc"]}
        pagemsg={"KYC Documents"}
        clientlogo={clientlogo}
      />}
      <div className="col-md-7 col-lg-8 onbo-content onbo-content-mbl">
        <div className="row">
          {/* Issuer T, TG, TGV */}
          <Fragment>
            {(((LinkTG!=="") && (kycDocLength==1|| kycstatus==3)) && !boloader) && (
            <div className="bo-on-screens position-relative onbo-content-center minh-row-mbl">
              <div className="col-md-12 col-lg-12">
                <div className="icon-alert">
                  <span className="icon-loading">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h3 className="mb-4">Click on the button below to complete your KYC verification</h3>

                <div className="form-group submit-field mt-4">
                  <a
                    href={LinkTG}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-large"
                    style={{ display: "inline-block", textDecoration: "none" }}
                  >
                    Complete KYC Verification
                  </a>
                </div>
                <div className="row mt-50">
                <div className="col-xl-3 mt-4">
                  <div className="form-group submit-field">
                    <button
                      className="btn btn-large"
                      onClick={() => { regeneratekyclink() }}
                    >
                      Regenerate Link
                    </button>
                  </div>
                </div>
                
                <div className="col-xl-3 mt-4">
                  <div className="form-group submit-field">
                    <a
                      className="btn btn-large"
                      onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
                    >
                      Logout
                    </a>
                  </div>
                </div>
                </div>
                
              
              </div>
            </div>
          )}
          {(((currentUser?.user?.IsKycSubmitted || successfulSubmitted) &&(kycDocLength==1||kycDocLength==2) &&(kycstatus!==4&&kycstatus!==3 && kycstatus!==0) ) && !boloader) && (
            <div className="bo-on-screens position-relative onbo-content-center minh-row-mbl">
              <div className="col-md-8 col-lg-5">
                <div className="icon-alert">
                  <span className="icon-loading">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h3 className="mb-4">We are reviewing your account</h3>

                <h6>
                  We are reviewing your uploaded documents. This usually take
                  less then 24 hours.
                </h6>
                <div className="form-group submit-field mt-40">
                  <button
                    className="btn btn-large w-100"
                    onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
                  >
                    Logout
                  </button>
                  
                </div>
              </div>
            </div>
          )}
          
           
          </Fragment>
        {/* Issuer Z*/}
         <Fragment>
         {
            (currentUser?.user?.IssuerName === "IssuerZ"||currentUser?.user?.IssuerName === "IssuerZD") && (kycstatus=="init"||kycstatus==0) && (
              <div className="bo-on-screens position-relative onbo-content-center minh-row-mbl">
              <div className="col-md-12 col-lg-12">
                <div className="icon-alert">
                  <span className="icon-loading">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h3 className="mb-4">Click on the link to complete kyc</h3>
                <div className="col-xl-3 mt-4">
                  <div className="form-group submit-field">
                  <a
                  href={LinkTG}
                  className="btn btn-large"
                  rel="noopener noreferrer"
                 
                >
                  Verify
                </a>
                  </div>
                </div>
                
                <div className="row mt-50">
                  {
                    currentUser?.user?.IssuerName === "IssuerZ" &&(
                      <div className="col-xl-3 mt-4">
                  <div className="form-group submit-field">
                    <button
                      className="btn btn-large"
                      onClick={() => { regeneratekyclinkZ() }}
                    >
                      Regenerate  Link
                    </button>
                  </div>
                </div>
                    )
                  }
                
                
                <div className="col-xl-3 mt-4">
                  <div className="form-group submit-field">
                    <a
                      className="btn btn-large"
                      onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
                    >
                      Logout
                    </a>
                  </div>
                </div>
                </div>
                
              
              </div>
            </div>
            )
          }
          {
            (currentUser?.user?.IssuerName === "IssuerZ"  ||currentUser?.user?.IssuerName === "IssuerZD") && (kycstatus!="Approved" &&kycstatus>1) &&(
              <div className="bo-on-screens position-relative onbo-content-center minh-row-mbl">
              <div className="col-md-8 col-lg-5">
                <div className="icon-alert">
                  <span className="icon-loading">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h3 className="mb-4">We are reviewing your account</h3>

                <h6>
                  We are reviewing your uploaded documents. This usually take
                  less then 24 hours.
                </h6>
                <div className="form-group submit-field mt-40">
                  <button
                    className="btn btn-large w-100"
                    onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
                  >
                    Logout
                  </button>
                  
                </div>
              </div>
            </div>
            )
          }
{

(currentUser?.user?.IssuerName === "IssuerZ"  ||currentUser?.user?.IssuerName === "IssuerZD") && (kycstatus=="Approved"|| kycstatus==1) &&
(<div className="">
  <div className="row">
    <div className="bo-on-screens position-relative">
      <div className="col-md-8 mb-5">
        <h3 className="mb-4">Card Activation</h3>
        <p>Please Enter your full name!</p>
      </div>
      <div className="col-md-8 col-lg-6 col-xl-5">
        <form >{
          }
          
            <div className="form-group" id="card_owner_name">
             <label htmlFor="email">Card Owner Name*</label>
             <div className="form-controls">
               <input
                 maxLength="50"
                 onInput={maxLengthCheck}
                 onWheel={(e) => e.target.blur()}
                 type="text"
                 value={CardOwnerName}
                 onChange={onChangeKCardOwnerName}
                 validations={[requiredCardOwnerName]}
                 placeholder="Card Owner Name is required !"
               />
               <span className="icon-email _ico"></span>
               
             </div>

           </div>
          
             
          
          <div className="row">
          <div className="col-xl-6 mt-4">
            <div className="form-group submit-field">
              <button className="btn btn-large w-100" onClick={submitCardVerification}>verify card{" "}</button>
            </div>
          </div>

          <div className="col-xl-6 mt-4">
            <div className="form-group submit-field">
              <button
                className="btn btn-large w-100"
                onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
              >
                Logout
              </button>
            </div>
          </div>
          </div>
          {/* <CheckButton style={{ display: "none" }} ref={checkBtn} /> */}
        </form>
      </div>
    </div>
  </div>
</div>)
}
{
<>
 {currentUser?.user?.IssuerName === "Issuer45" &&(
    <div className="">
    <div className="row">
      <div className="bo-on-screens position-relative">
        <div className="col-md-8 mb-5">
          <h3 className="mb-4">Card Activation</h3>
          <p>Your card is processing please check back later ! </p>
        </div>
        <div className="col-md-8 col-lg-6 col-xl-5">
          <form >{
            }
           
            <div className="row">
            
            <div className="col-xl-6 mt-4">
              <div className="form-group submit-field">
                <button
                  className="btn btn-large w-100"
                  onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
                >
                  Logout
                </button>
              </div>
            </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  )}
  
</>
}    
         </Fragment>        
        </div>
      </div>
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideallpopups={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />
      <ModelPopup
        key={1}
        show={modalsuccessfullShow}
        onHide={() => { setModalsuccessfullShow(false);  logoutUser(); }}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-42"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <div className="icon-alert icon-alert-popup">
                  <span className="icon-successful">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h2>Successful</h2>
                <div className="mt-16">
                  <div>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <p>All Done! Please Procceed to login!</p>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group submit-field mt-40 mb-0">
                          <button
                className="btn btn-large w-100"
                onClick={() => { sessionStorage.removeItem("user"); window.location.reload(); }}
              >
                Done
              </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
    </div>
  );
};

export default RegisterIssuerT;
